import React from 'react';
import {invoke} from './novaInvocationStore';
import {NovaAgentPicker} from './NovaAgentPicker';

export interface NovaAgentPickerForTaskProps {
	taskId: string;
	// See NovaAgentPickerProps.instanceKey (NovaAgentPicker.tsx) — must match whatever key the
	// sibling ConnectedNovaInvocationControl was given.
	instanceKey?: string;
}

// Deliberately no same-agent check or confirmation here, unlike ChangeAgentAffordance: this
// picker only opens from the caret while the control is in its bare `action` state (no run has
// started, nothing to lose), so every pick is a first invocation. Reusing this direct-invoke
// wrapper for a post-run "change agent" surface would skip ChangeAgentAffordance's data-loss
// warning entirely — that policy lives there, not in novaInvocationStore.invoke() itself.
export const NovaAgentPickerForTask = (props: NovaAgentPickerForTaskProps): JSX.Element => (
	<NovaAgentPicker
		taskId={props.taskId}
		instanceKey={props.instanceKey}
		onSelectAgent={agentId => invoke(props.taskId, agentId)}
	/>
);
